module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-lafluencers/02-feaf39080766797575f70f40f5802152.png";